import Navbar from "./Navbar";
import { ThemeProvider } from "./context/ThemeContext";
import Hero from "./Hero";
import Footer from "./Footer";
import { lazy, Suspense } from "react";

const AboutMe = lazy(() => import("./AboutMe"));
const Skills = lazy(() => import("./Skills"));
const Career = lazy(() => import("./Career"));
const Projects = lazy(() => import("./Projects"));
const Blog = lazy(() => import("./Blog"));
const Contact = lazy(() => import("./Contact"));

const App = () => {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-slate-50 dark:bg-[#0a0a0a] transition-colors duration-500">
        <header>
          <Navbar />
        </header>
        <div>
          <Hero />
          <Suspense fallback={null}>
            <AboutMe />
            <Skills />
            <Career />
            <Projects />
            <Blog />
            <Contact />
          </Suspense>
          <Footer />
        </div>
      </div>
    </ThemeProvider>
  );
};

export default App;
